import { render, staticRenderFns } from "./DefaultMessages.vue?vue&type=template&id=9c9b32d2"
import script from "./DefaultMessages.vue?vue&type=script&lang=js"
export * from "./DefaultMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports